const START_LOADER = 'START_LOADER';
const STOP_LOADER = 'STOP_LOADER';
const SET_PROGRESS_BAR_VALUE = 'SET_PROGRESS_BAR_VALUE';
export default {
  START_LOADER,
  STOP_LOADER,
  SET_PROGRESS_BAR_VALUE
};
